import CircleOcticon from '@github-ui/circle-octicon'
import {ReviewApprovedIcon} from '@github-ui/custom-icons/ReviewApprovedIcon'
import {CircleSlashIcon, ExclamationIcon, SkipIcon, XIcon, type Icon} from '@primer/octicons-react'

export type MiniStatusIconProps = {
  type: 'success' | 'warning' | 'failure' | 'neutral' | 'empty' | 'error'
}

type IconConfig = {Icon: Icon; className: string; iconSize?: number}

const configByType: Record<MiniStatusIconProps['type'], IconConfig> = {
  success: {
    Icon: ReviewApprovedIcon,
    iconSize: 12,
    className: 'fgColor-onEmphasis bgColor-success-emphasis',
  },
  warning: {Icon: ExclamationIcon, className: 'fgColor-onEmphasis bgColor-attention-emphasis'},
  failure: {
    Icon: XIcon,
    className: 'fgColor-onEmphasis bgColor-danger-emphasis',
  },
  neutral: {className: 'fgColor-muted bgColor-neutral-muted', Icon: CircleSlashIcon, iconSize: 16},
  empty: {className: 'fgColor-muted bgColor-neutral-muted', Icon: SkipIcon, iconSize: 16},
  error: {
    Icon: ExclamationIcon,
    className: 'fgColor-onEmphasis bgColor-danger-emphasis',
  },
}

export function MiniStatusIcon({type}: MiniStatusIconProps) {
  const {className, Icon, iconSize = 8} = configByType[type]

  return (
    <CircleOcticon
      className={className}
      data-testid={`mini-status-icon-${type}`}
      icon={() => <Icon size={iconSize} />}
      size={16}
    />
  )
}
